import { useQuery } from "@tanstack/react-query";

import SharedRecordAPI from "../../api/SharedRecordAPI";
import { ShareAuthType } from "../../../components/PageView/ShareScreenDrawer/ShareScreenDrawer";
import { View } from "../../../types/PageInterfaces";

interface Props {
  recordID: string;
  viewID: string;
}

interface Result {
  exists: boolean;
  id: string;
  Authentication: ShareAuthType;
  Password: string;
  SubViews: string[];
  View: View;
}

export default function useUserSharedRecordPage({ recordID, viewID }: Props) {
  const sharedRecordPage = useQuery<Result>({
    queryKey: ["userSharedRecordPage", recordID, viewID],
    queryFn: () =>
      SharedRecordAPI.GetSharedRecordPageInTenant(recordID, viewID).then(
        (data) => data?.data?.data
      ),
  });

  return {
    exists: sharedRecordPage.data?.exists,
    sharedRecordPageID: sharedRecordPage?.data?.id,
    authentication: sharedRecordPage?.data?.Authentication,
    view: sharedRecordPage?.data?.View,
    subviews: sharedRecordPage.data?.SubViews,
    password: sharedRecordPage?.data?.Password,
    recordPageLoading: sharedRecordPage.isLoading,
  };
}
